/**
 * Магазин токенов (BOT_SPEC §ШАГ 10) в стилистике карточек тарифов
 * из design-spec §7 (Profit Pass): пары «план — цена — фичи — CTA».
 */
import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';
import type { TokenPackage } from '../lib/api.js';
import { haptic, openTelegramLink } from '../lib/telegram.js';
import { useApp } from '../state/app.js';

export function TokensScreen({
  supportLink,
  tokensRate,
}: {
  /** Готовая ссылка на чат сапорта из `/api/config.links` (null — не задан). */
  supportLink: string | null;
  /** Курс «токенов за $1» — подставляется в текст бонусной карточки. */
  tokensRate: number;
}) {
  const { me, showToast, art, t, openWallet } = useApp();
  const [packages, setPackages] = useState<TokenPackage[]>([]);
  // единица начисления для текста про курс: «$1» или «100 ₽» (валюта витрины бота)
  const [unit, setUnit] = useState('$1');

  useEffect(() => {
    void api
      .packages()
      .then(({ packages: list, unit: packUnit }) => {
        setPackages(list);
        if (packUnit) setUnit(packUnit);
      })
      .catch(() => showToast(t('app.tokens.load_failed')));
  }, [showToast]);

  /**
   * Пополнение — в виджете брокера (шторка кошелька). Пакет уезжает вместе с
   * запросом сессии: депозит на его цену выдаст токены сам. Чужой аккаунт и
   * «нет привязки» шторка разруливает сама — уводит на экран аккаунта.
   */
  function openDeposit(packageId?: string) {
    haptic('medium');
    openWallet({
      mode: 'deposit',
      ...(packageId ? { packageId } : {}),
      stage: packageId ? `tokens:${packageId}` : 'tokens:bonus',
    });
  }

  return (
    <div className="screen">
      <section className="card card-lg card-violet">
        <span className="kicker">{t('app.tokens.promo')}</span>
        <h1 className="pass-title">
          {t('app.tokens.headline_lead')}
          <span className="grad-text">{t('app.tokens.headline_accent')}</span>
        </h1>
        <p className="body">
          {t('app.tokens.note')}
        </p>
        <div className="row-between">
          <span className="label">{t('app.tokens.you_have')}</span>
          <span className="pill">{me?.user.tokens ?? 0} 💎</span>
        </div>
      </section>

      <section className="pass-grid">
        {packages.map((pkg) => (
          <article
            key={pkg.id}
            className={`card pass-card ${pkg.badge === 'fire' ? 'is-pro' : ''}`}
          >
            {pkg.badge && (
              <span className={`pill ${pkg.badge === 'fire' ? 'pill-pink' : 'pill-green'} pass-badge`}>
                {pkg.badge === 'fire' ? t('app.tokens.badge_best') : t('app.tokens.badge_popular')}
              </span>
            )}
            <img
              className="pass-art art-3d"
              // у каждого пакета своя иконка (слот art.pack_<id>, набор заказчика 2026-09-18); незнакомый id — общая
              src={art(`art.${pkg.id}`, `/art/${pkg.id.replace('_', '-')}.svg`)}
              alt=""
              width={64}
              height={64}
            />
            <div className="pass-tokens">{pkg.tokens} 💎</div>
            {/* витрина в валюте бота: у ру-рынка рубли (подпись готовит сервер) */}
            <div className="pass-price">{pkg.price?.label ?? `$${pkg.priceUsd}`}</div>
            {/* золото — у того же пакета, что и золотая карточка (бейдж fire),
                а не у последнего по порядку (аудит UI 2026-08-21, A3) */}
            <button
              type="button"
              className={`cta ${pkg.badge === 'fire' ? 'cta-gold' : ''} cta-block`}
              onClick={() => void openDeposit(pkg.id)}
            >
              {t('app.tokens.buy')}
            </button>
          </article>
        ))}
      </section>

      <section className="card card-tinted bonus-card">
        <img className="bonus-art art-3d art-3d-slow" src={art('art.bonus', '/art/bonus.svg')} alt="" loading="lazy" />
        <span className="kicker">{t('app.tokens.smart_move')}</span>
        <h2 className="card-title">{t('app.tokens.bonus_title')}</h2>
        <p className="body">
          {t('app.tokens.bonus_text', { rate: tokensRate, unit })}
        </p>
        <button
          type="button"
          className="cta cta-gold cta-block"
          onClick={() => void openDeposit()}
        >
          {t('app.tokens.bonus_button')}
        </button>
      </section>

      <section className="card">
        <span className="label">{t('app.community.support')}</span>
        <p className="body">{t('app.tokens.leads_note')}</p>
        {/* чат сапорта открывается поверх прилы, не закрывая её */}
        {supportLink && (
          <button
            type="button"
            className="cta cta-secondary cta-block"
            onClick={() => {
              haptic();
              openTelegramLink(supportLink);
            }}
          >
            {t('app.community.support')}
          </button>
        )}
      </section>
    </div>
  );
}
